module.exports = __webpack_public_path__ + "img/37.5d7633e1.jpg";